export type MainEntity = 'course' | 'track'
export type CollectionEntity = 'collection' | 'roadmap' | 'program'

const BRAND_ROUTE_ENTITY_OVERRIDES: Record<
	string,
	{
		mainEntity?: MainEntity
		collectionEntity?: CollectionEntity
	}
> = {
	arkeias: {
		mainEntity: 'track',
		collectionEntity: 'program',
	},
	semyla: {
		collectionEntity: 'roadmap',
	},
	spabel: {
		collectionEntity: 'roadmap',
	},
}

type RuntimeBrandEnv = {
	BRAND?: string
	BRAND_MAIN_ENTITY?: MainEntity
	BRAND_COLLECTION_ENTITY?: CollectionEntity
}

function getRuntimeBrandEnv(): RuntimeBrandEnv | undefined {
	if (typeof window !== 'undefined') {
		return window.ENV
	}

	return (globalThis as typeof globalThis & { ENV?: RuntimeBrandEnv }).ENV
}

export function getRuntimeBrandKey(): string | undefined {
	return getRuntimeBrandEnv()?.BRAND ?? process.env.BRAND
}

export function getRuntimeMainEntity(): MainEntity | undefined {
	const envValue = getRuntimeBrandEnv()?.BRAND_MAIN_ENTITY
	if (envValue) return envValue
	return getMappedMainEntity(getRuntimeBrandKey())
}

export function getRuntimeCollectionEntity(): CollectionEntity | undefined {
	const envValue = getRuntimeBrandEnv()?.BRAND_COLLECTION_ENTITY
	if (envValue) return envValue
	return getMappedCollectionEntity(getRuntimeBrandKey())
}

export function getMappedMainEntity(
	brandKey?: string | null,
): MainEntity | undefined {
	if (!brandKey) return undefined
	return BRAND_ROUTE_ENTITY_OVERRIDES[brandKey]?.mainEntity
}

export function getMappedCollectionEntity(
	brandKey?: string | null,
): CollectionEntity | undefined {
	if (!brandKey) return undefined
	return BRAND_ROUTE_ENTITY_OVERRIDES[brandKey]?.collectionEntity
}
